import { ContainerModule, interfaces } from 'inversify';
import { AuthStore, IAuthStore } from './auth.store';

export const authModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IAuthStore.$).to(AuthStore).inSingletonScope();
});
